import Immutable from 'immutable';
import { RawSheet, Sheet } from 'records/Sheet';

export type SheetResponseId = string;

export interface RawSheetResponse {
  sheets: RawSheet[];
  cursor: string;
}

export interface SheetResponseData {
  sheets: Immutable.List<Sheet>;
  cursor: string;
}

const defaultValues: SheetResponseData = {
  sheets: Immutable.List(),
  cursor: '',
};

export const SheetResponseFactory = Immutable.Record(
  defaultValues,
  'SheetResponse'
);

export class SheetResponse extends SheetResponseFactory {
  static deserialize(rawSheetResponse: RawSheetResponse): SheetResponse {
    const sheets = rawSheetResponse.sheets.map(Sheet.deserialize);

    return new SheetResponse({
      ...rawSheetResponse,
      sheets: Immutable.List(sheets),
    });
  }

  serialize(): RawSheetResponse {
    return this.toJS();
  }
}
